import React, { useState } from "react";
import { Badge, Col, Row } from "react-bootstrap";
import { CommonButton, CommonInput, CommonSelect } from "../Input";
import DataTable from "../table/DataTable";
import BeneficiaryDetailsModal from "./BeneficiaryDetailsModal";
import { mockData } from "./mockData";

const BeneficiaryList = () => {
  // Filter states
  const [filters, setFilters] = useState({
    userId: "",
    beneficiaryId: "",
    beneficiaryName: "",
    receiverType: null,
    receivingMethod: null,
  });

  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedBeneficiary, setSelectedBeneficiary] = useState(null);

  const [filteredData, setFilteredData] = useState(mockData);

  const receiverTypeOptions = [
    { value: "Individual", label: "Individual" },
    { value: "Organization", label: "Organization" },
  ];

  const receivingMethodOptions = [
    { value: "Bank Transfer", label: "Bank Transfer" },
    { value: "Cash Pickup", label: "Cash Pickup" },
  ];

  const columns = [
    { label: "User ID", key: "userId" },
    {
      label: "User Name",
      key: "userName",
      render: (item) => <span className="text-black">{item.userName}</span>,
    },
    { label: "Beneficiary ID", key: "beneficiaryId" },
    {
      label: "Beneficiary name",
      key: "beneficiaryName",
      render: (item) => (
        <span className="text-black fw-bold">{item.beneficiaryName}</span>
      ),
    },
    { label: "Receiver type", key: "receiverType" },
    { label: "Receiving method", key: "receivingMethod" },
    { label: "Phone Number", key: "phone" },
    {
      label: "Status",
      key: "status",
      render: (item) =>
        item.status === "Approved" ? (
          <Badge
            bg="none"
            className="text-success border border-success px-2 py-1"
            style={{ fontSize: "10px", backgroundColor: "#E1F9ED" }}
          >
            Approved
          </Badge>
        ) : (
          item.status
        ),
    },
    {
      label: "Actions",
      key: "actions",
      className: "text-center",
      render: (item) => (
        <button
          className="btn btn-link p-0 text-muted"
          onClick={() => {
            setSelectedBeneficiary(item);
            setShowDetailsModal(true);
          }}
        >
          <i className="far fa-eye text-dark fs-16"></i>
        </button>
      ),
    },
  ];

  const handleSearch = () => {
    const result = mockData.filter((item) => {
      const matchUserId = filters.userId
        ? item.userId.toLowerCase().includes(filters.userId.toLowerCase())
        : true;
      const matchBnfId = filters.beneficiaryId
        ? item.beneficiaryId
            .toLowerCase()
            .includes(filters.beneficiaryId.toLowerCase())
        : true;
      const matchBnfName = filters.beneficiaryName
        ? item.beneficiaryName
            .toLowerCase()
            .includes(filters.beneficiaryName.toLowerCase())
        : true;
      const matchType = filters.receiverType
        ? item.receiverType === filters.receiverType.value
        : true;
      const matchMethod = filters.receivingMethod
        ? item.receivingMethod === filters.receivingMethod.value
        : true;

      return (
        matchUserId && matchBnfId && matchBnfName && matchType && matchMethod
      );
    });
    setFilteredData(result);
  };

  const handleReset = () => {
    const resetFilters = {
      userId: "",
      beneficiaryId: "",
      beneficiaryName: "",
      receiverType: null,
      receivingMethod: null,
    };
    setFilters(resetFilters);
    setFilteredData(mockData);
  };

  return (
    <div className="container-fluid">
      <div className="card mb-4" style={{ borderRadius: "10px" }}>
        <div className="card-body">
          <Row className="align-items-end gx-2 gy-3">
            <Col xl={2} lg={3} md={4} sm={6}>
              <CommonInput
                placeholder="Enter user ID"
                value={filters.userId}
                onChange={(e) =>
                  setFilters({ ...filters, userId: e.target.value })
                }
              />
            </Col>
            <Col xl={2} lg={3} md={4} sm={6}>
              <CommonInput
                placeholder="Enter beneficiary ID"
                value={filters.beneficiaryId}
                onChange={(e) =>
                  setFilters({ ...filters, beneficiaryId: e.target.value })
                }
              />
            </Col>
            <Col xl={2} lg={3} md={4} sm={12}>
              <CommonInput
                placeholder="Enter beneficiary name"
                value={filters.beneficiaryName}
                onChange={(e) =>
                  setFilters({ ...filters, beneficiaryName: e.target.value })
                }
              />
            </Col>
            <Col xl={2} lg={3} md={6} sm={6}>
              <CommonSelect
                placeholder="Select receiver type"
                options={receiverTypeOptions}
                value={filters.receiverType}
                onChange={(val) =>
                  setFilters({ ...filters, receiverType: val })
                }
              />
            </Col>
            <Col xl={2} lg={3} md={6} sm={6}>
              <CommonSelect
                placeholder="Select receiving method"
                options={receivingMethodOptions}
                value={filters.receivingMethod}
                onChange={(val) =>
                  setFilters({ ...filters, receivingMethod: val })
                }
              />
            </Col>
            <Col xl={2} lg={3} md={12} className="d-flex gap-2">
              <CommonButton onClick={handleReset} variant="outline">
                <i className="flaticon-381-repeat-1"></i>
              </CommonButton>
              <CommonButton onClick={handleSearch}>
                <i className="flaticon-381-search-1 fs-18 text-white"></i>
              </CommonButton>
            </Col>
          </Row>
        </div>
      </div>

      <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
        <div className="card-body">
          <DataTable
            columns={columns}
            data={filteredData}
            showPagination={false}
          />
        </div>
      </div>

      <BeneficiaryDetailsModal
        show={showDetailsModal}
        onHide={() => setShowDetailsModal(false)}
        beneficiary={selectedBeneficiary}
      />
    </div>
  );
};

export default BeneficiaryList;
